import * as angular from "angular";
import {IController} from "angular";
import {GroupsDialogService} from "../../services/groups-dialog.service";
import {GroupModel} from "../../models/group.model";
import {GroupsService} from "../../services/groups.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {GroupsHttpService} from "../../angular/services/groups-http.service";
import * as _ from "lodash";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {SortType} from "../../../commons/types/sort.type";

export class GroupsViewComponent implements IController {

  branchIds?: string[];
  tags?: string[];

  public loadLimit = 20;
  public queryString: string;
  public groups: GroupModel[];
  public cursor: string;
  public sortTypesValues: any;
  public selectedSortValue: any;
  private totalGroups: any;
  public isFetchingData: boolean;

  constructor(private groupsDialogService: GroupsDialogService, private groupsService: GroupsService, private groupsHttpService: GroupsHttpService,
              private commonsFacadeService: CommonsFacadeService, private $timeout, private $state) {
  }

  $onInit() {
    this.sortTypesValues = {
      sortCreatedAt: {asc: 'createdAt,asc', desc: 'createdAt,desc'},
      sortName: {asc: 'name,asc', desc: 'name,desc'},
    };
    this.selectedSortValue = undefined;

    this.groups = [];
    this.getGroups();
    this._reloadTotalGroups();
  };

  onCreateGroup() {
    this.groupsDialogService.createGroup()
      .then((group) => {
        this.createGroup(group);
      })
  }

  onEditGroup(group: GroupModel) {
    const groupCopy = angular.copy(group);
    this.groupsDialogService.editGroup(groupCopy)
      .then((group) => {
        this.editGroup(group);
      })
  }

  onDeleteGroup(group: GroupModel) {
    this.groupsDialogService.deleteGroup(group)
      .then((payload) => {
        if (!!payload.selectedGroupToMoveToId && !!payload.group.branchIds?.length) {
          this.addBranchesToGroup(payload.selectedGroupToMoveToId, payload.group.branchIds)
            .then(() => this.deleteGroup(group.id));
        } else {
          this.deleteGroup(group.id);
        }
      })
  }

  onQueryChange(query) {
    this.groups = [];
    this.queryString = query;
    this.cursor = undefined;
    this.getGroups();
  }

  onTagsChange(tags) {
    this.groups = [];
    this.tags = tags;
    this.cursor = undefined;
    this.getGroups();
    this._setQueryParams();
  }

  onBranchIdsChange(branchIds) {
    this.groups = [];
    this.branchIds = branchIds;
    this.cursor = undefined;
    this.getGroups();
    this._setQueryParams();
  }

  onSortTypeChange(sortName) {
    this.groups = [];
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this.getGroups();
  }


  _getGroupsQuery() {

    const params = {
      limit: this.loadLimit,
      query: this.queryString,
      tag: this.tags,
      branchId: this.branchIds,
      cursor: this.cursor,
      sort: _.get(this.selectedSortValue, 'value')
    }

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  getGroups(cursor?: string) {
    const params: any = this._getGroupsQuery();
    if (!!cursor) {
      params.cursor = cursor;
    }

    this.isFetchingData = true;
    this.commonsFacadeService.setLoaderOn();
    this.groupsHttpService.getGroups(params).subscribe({
      next: (res) => {
        this.cursor = res.cursor;
        this.groups = _.uniqBy([...this.groups, ...res.list], 'id');
        this.$timeout(() => {
        }, 0);
      },
      error: (error) => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      },
      complete: () => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      }
    });
  }

  fetchNext() {
    if (!this.cursor || this.isFetchingData) {
      return;
    }
    this.getGroups(this.cursor);
  }

  private createGroup(group: GroupModel) {
    this.groupsService.createGroup(group)
      .then((group: GroupModel) => {
        const groupsCopy = angular.copy(this.groups);
        groupsCopy.push(group);
        this.groups = groupsCopy;
        this._reloadTotalGroups();
      });
  }

  private _reloadTotalGroups() {
    this.totalGroups = undefined;
    this.groupsService.getTotalGroups()
      .then((total: any) => {
        this.totalGroups = total.total;
      })
      .catch((error) => {
      })
  }

  private editGroup(group: GroupModel) {
    this.groupsService.editGroup(group)
      .then((updatedGroup: GroupModel) => {
        const groupIndex = this.groups.findIndex(g => g.id === group.id);
        const groupsCopy = angular.copy(this.groups);
        groupsCopy[groupIndex] = updatedGroup;
        this.groups = groupsCopy;
      });
  }

  private addBranchesToGroup(groupId: string, branchIds: string[]) {
    return this.groupsService.addBranchesToGroup(groupId, branchIds);
  }

  private deleteGroup(groupId: string) {
    this.groupsService.deleteGroup(groupId)
      .then(() => {
        const groupIndex = this.groups.findIndex(g => g.id === groupId);
        const groupsCopy = angular.copy(this.groups);
        groupsCopy.splice(groupIndex, 1);
        this.groups = groupsCopy;
        this._reloadTotalGroups()
      });
  }

  private _setQueryParams() {
    this.$state.go('.', {
      branchIds: this.branchIds,
      tags: this.tags
    }, {
      notify: false,
      reload: false
    })
  }

}

angular
  .module('bringoz.admin.groups')
  .component('groupsView', {
    bindings: {
      branchIds: '<?',
      tags: '<?'
    },
    template: require('./groups-view.html').default,
    controller: GroupsViewComponent
  });
